var _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

const SvgAnalyst2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.515,
    height: 13.247,
    viewBox: "0 0 16.515 13.247",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_163_1",
    "data-name": "Component 163 \\u2013 1",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M0,11.4V9.979C0,8.411,2.566,7.128,5.7,7.128s5.7,1.283,5.7,2.852V11.4ZM2.851,2.852A2.851,2.851,0,1,1,5.7,5.7,2.851,2.851,0,0,1,2.851,2.852Z",
    transform: "translate(0 1.342)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M-4741,16010.571v-.452h10.31v9.424h-4.2",
    transform: "translate(4746.701 -16010.119)",
    fill: "none",
    stroke: "#ffb300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1291",
    "data-name": "Rectangle 1291",
    transform: "translate(11.404 2.767)",
    fill: "#ffb300",
    stroke: "#ffb300",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.426,
    height: 5.702,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.426,
    height: 4.702,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1292",
    "data-name": "Rectangle 1292",
    transform: "translate(9.268 5.618)",
    fill: "#ffb300",
    stroke: "#ffb300",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.426,
    height: 2.851,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.426,
    height: 1.851,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1293",
    "data-name": "Rectangle 1293",
    transform: "translate(13.543 1.342)",
    fill: "#ffb300",
    stroke: "#ffb300",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.426,
    height: 7.128,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.426,
    height: 6.128,
    fill: "none"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAnalyst2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Analyst_2.53827585.svg";
export { ForwardRef as ReactComponent };